module.exports = __webpack_public_path__ + "static/img/design-6.91dc8e91.png";